(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-arcade"] && !Shopify.designMode) return;
  try {
    
  /*-------- KC ARCADE — launch, exit, and the Klaviyo hand-off --------*/
  (function () {
    'use strict';

    var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var KLAVIYO_REVISION = '2024-10-15';

    function init(root) {
      if (root.dataset.kcArcadeReady) return;
      root.dataset.kcArcadeReady = 'true';

      var launch = root.querySelector('[data-kc-arcade-launch]');
      var game = root.querySelector('[data-kc-arcade-game]');
      var iframe = root.querySelector('[data-kc-arcade-iframe]');
      var exitBtn = root.querySelector('[data-kc-arcade-exit]');
      if (!launch || !game || !iframe) return;

      var gameUrl = root.dataset.gameUrl;
      var gameOrigin = resolveOrigin(root.dataset.gameOrigin, gameUrl);
      var isOpen = false;
      var warmed = false;
      var lastFocus = null;

      /* Boot the game before the click lands. It sits in a hidden, zero-opacity
         box, so three.js compiles and the first frames composite while the room
         is still being looked at. Without this the first launch stalls on a
         cold WebGL boot. */
      function prewarm() {
        if (warmed || !gameUrl) return;
        warmed = true;

        // Forward share-link attribution into the game
        var kcParams = new URLSearchParams(window.location.search);
        if (kcParams.has('by') || kcParams.has('mi')) {
          gameUrl += (gameUrl.indexOf('?') > -1 ? '&' : '?') + 'ref=share'
            + (kcParams.has('by') ? '&via=' + encodeURIComponent(kcParams.get('by')) : '');
        }

        /* Where the game's own X should send fans when it closes the takeover.
           Read off the live URL rather than hardcoded, so it is right on
           production, on the myshopify domain and inside a preview theme,
           where the preview_theme_id params have to survive the trip. Share
           params come off so the return does not re-fire attribution, and the
           hash goes so it cannot land back on #play and reopen the game. */
        try {
          var exitUrl = new URL(window.location.href);
          exitUrl.hash = '';
          exitUrl.searchParams.delete('by');
          exitUrl.searchParams.delete('mi');
          gameUrl += (gameUrl.indexOf('?') > -1 ? '&' : '?')
            + 'exit=' + encodeURIComponent(exitUrl.toString());
        } catch (_) { /* fail-soft: the game falls back to its own default */ }

        iframe.src = gameUrl;
      }

      launch.addEventListener('pointerenter', prewarm);
      launch.addEventListener('focus', prewarm);
      window.addEventListener('load', function () {
        window.setTimeout(prewarm, 1500);
      });

      /* Announce the host to the game. Its own back control posts to
         window.location.origin, which the browser refuses to deliver when the
         parent is a different site, so the button renders dead. The host origin
         cannot be hardcoded on their side: it differs per store, per Shopify
         preview theme and per custom domain. This gives them one to answer to.
         Sent on frame load and again on open, since the frame is pre-warmed and
         may boot before their listener is attached. */
      function greet() {
        if (!gameOrigin || !iframe.contentWindow) return;
        try {
          iframe.contentWindow.postMessage(
            { source: 'kc-arcade-host', type: 'hello' },
            gameOrigin
          );
        } catch (_) { /* fail-soft */ }
      }

      iframe.addEventListener('load', greet);

      /* fromHistory: the browser moved us here, so do not push another entry. */
      function open(fromHistory) {
        if (isOpen) return;
        isOpen = true;
        lastFocus = document.activeElement;
        prewarm();

        /* Give the game its own history entry so Back closes it instead of
           leaving the site, and so the URL matches the one score shares use. */
        if (!fromHistory) {
          try { history.pushState({ kcArcade: 1 }, '', '#play'); } catch (_) { /* fail-soft */ }
        }

        /* Move to <body> so nothing in the section's ancestry can clip it. */
        if (game.parentNode !== document.body) document.body.appendChild(game);
        game.hidden = false;
        void game.offsetWidth;
        game.classList.add('kc-arcade__game--on');
        document.documentElement.classList.add('kc-arcade-locked');
        document.body.classList.add('kc-arcade-locked');
        root.dispatchEvent(new CustomEvent('kc-arcade:game', { detail: { open: true } }));
        greet();
        if (exitBtn) exitBtn.focus({ preventScroll: true });
        else iframe.focus({ preventScroll: true });
      }

      function close(fromHistory) {
        if (!isOpen) return;
        isOpen = false;

        if (!fromHistory && history.state && history.state.kcArcade) {
          try { history.back(); } catch (_) { /* fail-soft */ }
        }
        game.classList.remove('kc-arcade__game--on');
        document.documentElement.classList.remove('kc-arcade-locked');
        document.body.classList.remove('kc-arcade-locked');
        root.dispatchEvent(new CustomEvent('kc-arcade:game', { detail: { open: false } }));

        window.setTimeout(function () {
          if (isOpen) return;
          game.hidden = true;
          /* Drop the game so it stops consuming a WebGL context and audio in
             the background. The next launch re-warms from the hotspot. */
          iframe.src = '';
          warmed = false;
        }, 300);

        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
        lastFocus = null;
      }

      /* Wrapped, not passed directly: a listener hands the event to its
         callback, and a truthy first argument here means "the browser moved
         us", which would suppress the history entry on every click. */
      launch.addEventListener('click', function () { open(); });
      if (exitBtn) exitBtn.addEventListener('click', function () { close(); });

      window.addEventListener('popstate', function () {
        if (isOpen) close(true);
        else if (window.location.hash === '#play') open(true);
      });

      window.addEventListener('hashchange', function () {
        if (window.location.hash === '#play') open(true);
      });

      /* Arriving on a shared link. The entry is already ours, so no push. */
      if (window.location.hash === '#play') open(true);

      /*-------- attract screen: the CRT alternating between the game's own
         picture and a high-score board, the way a cabinet on standby does --------*/
      (function attract() {
        var panel = root.querySelector('[data-kc-arcade-attract]');
        var ticker = root.querySelector('[data-kc-arcade-ticker]');
        if (!panel || !ticker) return;

        var entries = (root.dataset.attractEntries || '')
          .split('\n')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
        if (!entries.length) return;

        var onMs = parseInt(root.dataset.attractOn, 10) || 5000;
        var offMs = parseInt(root.dataset.attractOff, 10) || 5000;
        var i = 0;
        var timer = null;

        function show() {
          ticker.textContent = entries[i % entries.length];
          i++;
          panel.classList.add('kc-arcade__attract--on');
          timer = window.setTimeout(hide, onMs);
        }

        function hide() {
          panel.classList.remove('kc-arcade__attract--on');
          timer = window.setTimeout(show, offMs);
        }

        function stop() {
          window.clearTimeout(timer);
          timer = null;
          panel.classList.remove('kc-arcade__attract--on');
        }

        function start() {
          if (timer || isOpen) return;
          timer = window.setTimeout(show, offMs);
        }

        /* Nothing animates while the game is up, while the tab is hidden, or
           while the section is off screen. An idle cabinet should not keep a
           backdrop-filter repainting behind a full-screen WebGL canvas. */
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop(); else start();
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (rows) {
            rows.forEach(function (row) {
              if (row.isIntersecting) start(); else stop();
            });
          }, { threshold: 0.01 }).observe(root);
        } else {
          start();
        }

        root.addEventListener('kc-arcade:game', function (ev) {
          if (ev.detail && ev.detail.open) stop(); else start();
        });
      })();

      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && isOpen) close();
      });

      /* Their own exit, once it reaches us. Handled below in the message
         listener; kept here as the reason the exit button can be switched off
         rather than needing to be deleted. */

      /*-------- messages from the game --------*/
      window.addEventListener('message', function (ev) {
        if (gameOrigin && ev.origin !== gameOrigin) return;
        if (ev.source !== iframe.contentWindow) return;

        var data = ev.data;
        if (!data || typeof data !== 'object') return;
        if (data.source !== 'burnmyboat') return;

        /* Their own back control. It currently posts with its own origin as
           the target, so this never fires from a storefront host — harmless to
           listen for, and it starts working the moment that is fixed. */
        if (data.type === 'exit') close();
        else if (data.type === 'signup') subscribe(data.payload || {});
      });

      /*-------- Klaviyo — FALLBACK ONLY, normally inert --------*/
      /* The game writes to Klaviyo itself, so this must not fire as well: one
         signup filing two subscription calls would double the consent events
         on a single profile. It stays dead because the company id and list id
         are deliberately blank, and it bails on either being empty. Kept as a
         way back if the game ever stops owning the write. Public key only if
         it is ever filled in; no private key belongs in a browser. */
      function subscribe(payload) {
        var companyId = root.dataset.klaviyoCompany;
        var listId = root.dataset.klaviyoList;
        var email = (payload.email || '').trim();
        if (!companyId || !listId || !email) return;

        var props = {};
        if (payload.name) props.$first_name = payload.name;
        if (payload.phone) props.$phone_number = payload.phone;
        if (payload.birthday) props.Birthday = payload.birthday;
        if (payload.score != null) props.arcade_best_score = payload.score;
        if (payload.game) props.arcade_game = payload.game;
        props.arcade_signup_source = root.dataset.klaviyoSource || 'ssm-arcade';

        var profile = { type: 'profile', attributes: { email: email, properties: props } };
        if (payload.phone) profile.attributes.phone_number = payload.phone;

        fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { profile: { data: profile } },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).catch(function () { /* never let a list write break the game */ });
      }
    }

    function resolveOrigin(explicit, url) {
      if (explicit) return explicit;
      if (!url) return '';
      try {
        return new URL(url, window.location.href).origin;
      } catch (_) {
        return '';
      }
    }

    function boot() {
      document.querySelectorAll('[data-kc-arcade]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var root = ev.target.querySelector('[data-kc-arcade]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-article-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopStory(root) {
      if (!root || root.dataset.kcInit) return;
      root.dataset.kcInit = '1';

      var teaser = root.querySelector('.kc-shop-story__teaser');
      if (!teaser) return;

      var target = document.querySelector('.kc-related-products');
      // No related-products row on the page -> the pill has nowhere to go.
      if (!target) {
        root.style.display = 'none';
        return;
      }

      teaser.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Tuck the pill away once the footer comes into view.
      var footer = document.querySelector('#footer-group, footer, .footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              root.classList.toggle('kc-shop-story--hidden', entry.isIntersecting);
            });
          },
          { rootMargin: '0px' }
        ).observe(footer);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-kc-shop-story]').forEach(initShopStory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.kc-topbar').forEach(function (root) {
      if (root.dataset.kcSectionInit === '1') return;
      root.dataset.kcSectionInit = '1';

      /*-------- ESCAPE THE HEADER-GROUP STACKING CONTEXT --------
         Detach from the header section wrapper and prepend directly to <body>
         so the bar can paint over the sticky header regardless of z-index. */
      if (root.parentElement !== document.body) {
        document.body.prepend(root);
      }

      /*-------- SCROLL SHADOW --------*/
      window.addEventListener('scroll', function () {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
      }, { passive: true });

      /*-------- BODY OFFSET WHEN FIXED --------
         When the bar is fixed it leaves the flow, so push body content down
         by the bar's current height. Re-measured on every reflow. */
      if (root.classList.contains('kc-topbar--sticky')) {
        document.body.classList.add('has-kc-topbar');
        var setOffset = function () {
          document.body.style.setProperty('--kc-topbar-h', root.offsetHeight + 'px');
        };
        setOffset();
        if (window.ResizeObserver) {
          new ResizeObserver(setOffset).observe(root);
        } else {
          window.addEventListener('resize', setOffset);
        }
      }

      /*-------- BLOCK CAROUSEL --------
         With more blocks than fit (2 on desktop, 1 on mobile), slide them
         through. Auto-advances, pauses on hover/focus, loops seamlessly. */
      (function initCarousel() {
        var viewport = root.querySelector('[data-kc-viewport]');
        var track    = root.querySelector('[data-kc-track]');
        var dotsWrap = root.querySelector('[data-kc-dots]');
        if (!viewport || !track) return;

        var realSlides = Array.prototype.slice.call(track.children);
        var activeSlides = realSlides.slice();
        var N = activeSlides.length;
        var CLONES = 2; // max slides visible at once (desktop)

        var mqMobile    = window.matchMedia('(max-width: 749px)');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var rotateMs = (parseFloat(root.dataset.kcRotate) || 5) * 1000;

        var clones = [], index = 0, timer = null, paused = false;

        function visibleCount() { return mqMobile.matches ? 1 : 2; }

        function isMobileEnabled(slide) {
          var block = slide.querySelector('[data-kc-mobile-enabled]');
          return !block || block.dataset.kcMobileEnabled !== 'false';
        }

        function getActiveSlides() {
          if (!mqMobile.matches) return realSlides.slice();
          return realSlides.filter(isMobileEnabled);
        }

        // Hold position while the user is interacting: hovering/typing (paused)
        // or actively playing the song (root has .is-playing).
        function isHeld() { return paused || root.classList.contains('is-playing'); }

        function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
        function startAuto() {
          stopAuto();
          if (reduceMotion.matches) return;
          timer = setInterval(function () { if (!isHeld()) next(); }, rotateMs);
        }

        function teardown() {
          root.classList.remove('kc-topbar--carousel');
          clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
          clones = [];
          realSlides.forEach(function (s) {
            s.classList.remove('is-slide-left', 'is-slide-right', 'kc-topbar__slot--left', 'kc-topbar__slot--right');
            s.style.display = '';
          });
          if (dotsWrap) dotsWrap.innerHTML = '';
          track.style.transform = '';
          viewport.style.height = '';
          index = 0;
          stopAuto();
        }

        function apply(animate) {
          if (!activeSlides.length) return;
          var w = activeSlides[0].getBoundingClientRect().width;
          if (!animate) {
            track.classList.add('is-snapping');
            track.style.transform = 'translateX(' + (-index * w) + 'px)';
            void track.offsetWidth; // force reflow
            track.classList.remove('is-snapping');
          } else {
            track.style.transform = 'translateX(' + (-index * w) + 'px)';
          }
          updateAlignment();
        }

        function updateAlignment() {
          var items = activeSlides.concat(clones);
          for (var i = 0; i < items.length; i++) {
            items[i].classList.remove('is-slide-left', 'is-slide-right', 'kc-topbar__slot--left', 'kc-topbar__slot--right');
          }
          if (visibleCount() < 2) return; // mobile: single centered slide
          var leftEl = items[index], rightEl = items[index + 1];
          if (leftEl)  leftEl.classList.add('is-slide-left', 'kc-topbar__slot--left');
          if (rightEl) rightEl.classList.add('is-slide-right', 'kc-topbar__slot--right');
        }

        function updateDots() {
          if (!dotsWrap) return;
          var active = ((index % N) + N) % N;
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.classList.toggle('is-active', i === active);
          });
        }

        function goTo(i) { index = i; apply(true); updateDots(); }
        function next() { index++; apply(true); updateDots(); }

        track.addEventListener('transitionend', function (e) {
          if (e.propertyName !== 'transform') return;
          if (index >= N) { index -= N; apply(false); updateDots(); }
        });

        function build() {
          teardown();
          activeSlides = getActiveSlides();
          N = activeSlides.length;

          realSlides.forEach(function (slide) {
            slide.style.display = activeSlides.indexOf(slide) === -1 ? 'none' : '';
          });

          if (!N) {
            viewport.style.height = '0px';
            return;
          }

          if (N <= visibleCount()) return;

          root.classList.add('kc-topbar--carousel');

          for (var i = 0; i < Math.min(CLONES, N); i++) {
            var c = activeSlides[i].cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.dataset.kcClone = '1';
            c.style.pointerEvents = 'none';
            // Clones are visual only — never let a cloned player spin up audio.
            c.querySelectorAll('iframe').forEach(function (el) { el.remove(); });
            c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
            c.querySelectorAll('input, button, a, select, textarea, iframe').forEach(function (el) {
              el.setAttribute('tabindex', '-1');
              if ('disabled' in el) { try { el.disabled = true; } catch (e) {} }
            });
            track.appendChild(c);
            clones.push(c);
          }

          var maxH = 0;
          activeSlides.forEach(function (s) { maxH = Math.max(maxH, s.offsetHeight); });
          if (maxH > 0) viewport.style.height = maxH + 'px';

          if (dotsWrap) {
            dotsWrap.innerHTML = '';
            for (var d = 0; d < N; d++) {
              (function (d) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'kc-topbar__dot';
                b.setAttribute('aria-label', 'Show item ' + (d + 1));
                b.addEventListener('click', function () { goTo(d); startAuto(); });
                dotsWrap.appendChild(b);
              })(d);
            }
          }

          index = 0;
          apply(false);
          updateDots();
          startAuto();
        }

        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        root.addEventListener('focusin',  function () { paused = true; });
        root.addEventListener('focusout', function () { paused = false; });

        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(build, 200);
        });

        build();
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-divider"] && !Shopify.designMode) return;
  try {
    
  /*-------- WAVE DIVIDER (animated) --------
     Mirrors v4.html: 3-layer sine surface drifted by time + scroll velocity.
     One shared scroll listener + RAF loop drives every instance on the page. */
  (function () {
    var W = 1440, H = 100;
    var divs = document.querySelectorAll('.kc-wave');
    if (!divs.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rngFromSeed(seed) {
      var s = (seed * 16807) % 2147483647;
      return function () {
        s = (s * 16807) % 2147483647;
        return s / 2147483647;
      };
    }

    var dividers = [];

    divs.forEach(function (div) {
      // Skip if already initialized (Shopify can re-render the same section)
      if (div.dataset.kcWaveReady === '1') return;
      div.dataset.kcWaveReady = '1';

      var seedIn = parseInt(div.dataset.seed, 10) || 1;
      var seed = seedIn * 9301 + Math.floor(Math.random() * 9999);
      var rand = rngFromSeed(seed);
      var topFill = div.dataset.topFill || 'transparent';
      var bottomFill = div.dataset.bottomFill || 'transparent';

      // Three sine layers — primary swell, counter-rhythm, fine surface texture.
      var layers = [
        { baseAmp: 4 + rand() * 2, idleAmp: 14 + rand() * 4, velAmp: 22,
          freq: 0.7 + rand() * 0.25, phase: rand() * Math.PI * 2,
          speed: 0.00018 + rand() * 0.00010 },
        { baseAmp: 2.5 + rand() * 1.5, idleAmp: 7 + rand() * 3, velAmp: 13,
          freq: 1.3 + rand() * 0.4, phase: rand() * Math.PI * 2,
          speed: 0.00040 + rand() * 0.00018 },
        { baseAmp: 1.2 + rand() * 0.8, idleAmp: 2.5 + rand() * 1.2, velAmp: 5,
          freq: 2.6 + rand() * 1.0, phase: rand() * Math.PI * 2,
          speed: 0.00080 + rand() * 0.00030 }
      ];

      div.innerHTML =
        '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path class="kc-wave__top" d="" fill="' + topFill + '"/>' +
        '<path class="kc-wave__bottom" d="" fill="' + bottomFill + '"/>' +
        '</svg>';

      var animate = div.dataset.animate === 'true';
      dividers.push({
        topPath: div.querySelector('.kc-wave__top'),
        bottomPath: div.querySelector('.kc-wave__bottom'),
        layers: layers,
        baseline: H * 0.5 + (rand() - 0.5) * 6,
        animate: animate && !reduceMotion
      });
    });

    function renderPaths(d, t, velocity) {
      var layers = d.layers, baseline = d.baseline, STEPS = 64;
      var isMobile = window.innerWidth <= 600;
      var isTablet = !isMobile && window.innerWidth <= 900;
      var ampScale = isMobile ? 0.8 : (isTablet ? 0.85 : 1);
      var freqScale = isMobile ? 0.55 : (isTablet ? 0.78 : 1);
      var velAmpScale = isMobile ? 0.8 : (isTablet ? 0.75 : 1);
      // Drift faster on mobile so the idle motion is visible without scrolling.
      var timeScale = isMobile ? 1.8 : (isTablet ? 1.3 : 1);

      var vAbs = Math.min(100, Math.abs(velocity));
      var vMag = Math.sqrt(vAbs / 100);
      var vDir = Math.sign(velocity);

      // On mobile, drop the scroll-inertia response: touch/momentum scroll velocity
      // is unreliable, so the velocity-driven waves flatten right when they're in
      // view. Zero it out so the idle waves stay at full amplitude and the time
      // drift animates them on its own (always wavy, no scrolling required).
      if (isMobile) {
        vMag = 0;
        vDir = 0;
        velocity = 0;
      }

      var pts = [];
      for (var i = 0; i <= STEPS; i++) {
        var x = (W / STEPS) * i;
        var u = x / W;
        var y = baseline;
        for (var j = 0; j < layers.length; j++) {
          var L = layers[j];
          var idle = (L.idleAmp || 0) * (1 - vMag);
          var driven = L.velAmp * vMag * velAmpScale;
          var amp = (L.baseAmp + idle + driven) * ampScale;
          var freq = L.freq * freqScale;
          var phaseShift = vDir * freq * vMag * 1.4;
          y += Math.sin(u * Math.PI * 2 * freq + L.phase + t * L.speed * 1000 * timeScale + phaseShift) * amp;
        }
        y += velocity * 0.05 * ampScale * (u - 0.5);
        pts.push({ x: x, y: y });
      }

      var curve = 'M0,' + pts[0].y.toFixed(2);
      for (var k = 0; k < pts.length - 1; k++) {
        var p0 = pts[Math.max(0, k - 1)];
        var p1 = pts[k];
        var p2 = pts[k + 1];
        var p3 = pts[Math.min(pts.length - 1, k + 2)];
        var t1x = p1.x + (p2.x - p0.x) / 6;
        var t1y = p1.y + (p2.y - p0.y) / 6;
        var t2x = p2.x - (p3.x - p1.x) / 6;
        var t2y = p2.y - (p3.y - p1.y) / 6;
        curve += ' C' + t1x.toFixed(2) + ',' + t1y.toFixed(2) + ' ' +
                 t2x.toFixed(2) + ',' + t2y.toFixed(2) + ' ' +
                 p2.x.toFixed(2) + ',' + p2.y.toFixed(2);
      }
      return {
        top: curve + ' L' + W + ',0 L0,0 Z',
        bottom: curve + ' L' + W + ',' + H + ' L0,' + H + ' Z'
      };
    }

    // Initial render so every divider has shape immediately.
    dividers.forEach(function (d) {
      var paths = renderPaths(d, 0, 0);
      d.topPath.setAttribute('d', paths.top);
      d.bottomPath.setAttribute('d', paths.bottom);
    });

    // Bail out of the loop if nothing wants animation.
    var anyAnimated = dividers.some(function (d) { return d.animate; });
    if (!anyAnimated) return;

    // Shared scroll-velocity tracking — single listener, one smoothed value.
    var lastY = window.scrollY, raw = 0, smooth = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      raw = y - lastY;
      lastY = y;
    }, { passive: true });

    var start = performance.now();
    function tick(now) {
      var t = (now - start) / 1000;
      smooth += (raw - smooth) * 0.08;
      raw *= 0.88;
      var v = Math.max(-200, Math.min(200, smooth));

      for (var i = 0; i < dividers.length; i++) {
        var d = dividers[i];
        if (!d.animate) continue;
        var svg = d.bottomPath.ownerSVGElement;
        var rect = svg.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > window.innerHeight + 100) continue;
        var paths = renderPaths(d, t, v);
        d.topPath.setAttribute('d', paths.top);
        d.bottomPath.setAttribute('d', paths.bottom);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  } catch(e) { console.error(e); }
})();
})();
